/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { LeadWaitlistDetails } from './LeadWaitlistDetails';
import {
    LeadWaitlistDetailsFromJSON,
    LeadWaitlistDetailsFromJSONTyped,
    LeadWaitlistDetailsToJSON,
    LeadWaitlistDetailsToJSONTyped,
} from './LeadWaitlistDetails';
import type { LeadWaitlistUpdatesInner } from './LeadWaitlistUpdatesInner';
import {
    LeadWaitlistUpdatesInnerFromJSON,
    LeadWaitlistUpdatesInnerFromJSONTyped,
    LeadWaitlistUpdatesInnerToJSON,
    LeadWaitlistUpdatesInnerToJSONTyped,
} from './LeadWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface LeadWaitlist
 */
export interface LeadWaitlist {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    status?: LeadWaitlistStatusEnum;
    /**
     * 
     */
    details?: LeadWaitlistDetails;
    /**
     * 
     */
    rank?: number;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    status_set_by_user?: User;
    /**
     * 
     */
    receipt_id?: string;
    /**
     * 
     */
    updates?: Array<LeadWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const LeadWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled',
} as const;
export type LeadWaitlistStatusEnum = typeof LeadWaitlistStatusEnum[keyof typeof LeadWaitlistStatusEnum];


/**
 * Check if a given object implements the LeadWaitlist interface.
 */
export function instanceOfLeadWaitlist(value: object): value is LeadWaitlist {
    return true;
}

export function LeadWaitlistFromJSON(json: any): LeadWaitlist {
    return LeadWaitlistFromJSONTyped(json, false);
}

export function LeadWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWaitlist {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'details': json['details'] == null ? undefined : LeadWaitlistDetailsFromJSON(json['details']),
        'rank': json['rank'] == null ? undefined : json['rank'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'status_set_by_user': json['status_set_by_user'] == null ? undefined : UserFromJSON(json['status_set_by_user']),
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'updates': json['updates'] == null ? undefined : ((json['updates'] as Array<any>).map(LeadWaitlistUpdatesInnerFromJSON)),
    };
}

export function LeadWaitlistToJSON(json: any): LeadWaitlist {
    return LeadWaitlistToJSONTyped(json, false);
}

export function LeadWaitlistToJSONTyped(value?: LeadWaitlist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'status': value['status'],
        'details': LeadWaitlistDetailsToJSON(value['details']),
        'rank': value['rank'],
        'created_at': value['created_at'],
        'status_set_by_user': UserToJSON(value['status_set_by_user']),
        'receipt_id': value['receipt_id'],
        'updates': value['updates'] == null ? undefined : ((value['updates'] as Array<any>).map(LeadWaitlistUpdatesInnerToJSON)),
    };
}

